import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Award } from 'lucide-react';
export function Masterclass() {
  const handleBooking = () => {
    window.open('https://studiomery.koob.uy', '_blank', 'noopener,noreferrer');
  };
  const photos = ['https://cdn.magicpatterns.com/uploads/wgBvWdsAuyUYGFYF5qKNLG/SaveClip.App_572658116_17946447408062830_8601366030392346030_n.jpg', 'https://cdn.magicpatterns.com/uploads/4iFYC1nd1VTPagLzi7UFry/SaveClip.App_572668826_17946447435062830_3255619687329959390_n.jpg', 'https://cdn.magicpatterns.com/uploads/15MC1a5jBUSe5h2RAwGJAx/SaveClip.App_573509214_17946447417062830_661183521740405522_n.jpg', 'https://cdn.magicpatterns.com/uploads/7gRXnZr7YnGj9pYm743y3c/SaveClip.App_576080341_17946447396062830_8741050531439278808_n.jpg'];
  return <section className="py-24 bg-white" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-179">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-180">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-rosegold tracking-widest uppercase mb-3" data-id="element-181">
            <GraduationCap size={18} data-id="element-182" />
            Masterclass & Capacitaciones
          </span>
          <h3 className="text-4xl md:text-5xl font-serif text-charcoal mb-5 leading-tight" data-id="element-183">
            Formá parte de nuestras alumnas certificadas
          </h3>
          <p className="text-charcoal-light text-lg font-light leading-relaxed" data-id="element-184">
            Mery comparte su conocimiento en cursos profesionales de diseño de
            cejas, laminado y pestañas. Cada alumna se lleva técnica, práctica y
            su certificado de reconocimiento.
          </p>
        </div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={{
        hidden: {
          opacity: 0
        },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.12
          }
        }
      }} className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-185">
          {photos.map((src, idx) => <motion.div key={idx} variants={{
          hidden: {
            opacity: 0,
            y: 20
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.5
            }
          }
        }} className="group relative aspect-[4/5] rounded-2xl overflow-hidden shadow-sm" data-id="element-186">
              <img src={src} alt={`Alumna certificada de Studio by Mery ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-187" />
              <div className="absolute bottom-3 left-3" data-id="element-188">
                <span className="inline-flex items-center gap-1.5 bg-white/90 backdrop-blur-sm text-charcoal text-xs font-medium px-3 py-1.5 rounded-full shadow-sm" data-id="element-189">
                  <Award size={13} className="text-rosegold" data-id="element-190" />
                  Certificada
                </span>
              </div>
            </motion.div>)}
        </motion.div>

        <div className="text-center mt-14" data-id="element-191">
          <button onClick={handleBooking} className="bg-charcoal text-white px-8 py-3.5 rounded-full font-medium hover:bg-charcoal-light transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-192">
            Consultá por la próxima Masterclass
          </button>
        </div>
      </div>
    </section>;
}